export class InformacionInicioDto{
  direccionIp: string;
  sede: string;
  ciudad: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/informacion-inicio-dto.ts